// REQ-396: per-note mutation-queue key. A note has no sidebar (unlike eref/ecall/furniture), so
// this lives alongside the note interaction hooks instead of a `*Sidebar/` folder — mirrors
// `erefQueueKey.ts` / `ecallQueueKey.ts` / `furnitureQueueKey.ts`.
export const noteQueueKey = (noteId: number) => `note-${noteId}`
